"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Refresh_exports = {};
__export(Refresh_exports, {
  default: () => Refresh_default
});
module.exports = __toCommonJS(Refresh_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.96484 5.19141C7.5638 4.85286 8.18229 4.625 8.82031 4.50781C9.47135 4.39062 10.1094 4.38411 10.7344 4.48828C11.3724 4.57943 11.9844 4.76823 12.5703 5.05469C13.1562 5.35417 13.6901 5.74479 14.1719 6.22656L15.9492 7.96484V5.66016C15.9492 5.50391 16.0013 5.36719 16.1055 5.25C16.2096 5.13281 16.3333 5.06771 16.4766 5.05469L16.5547 5.03516C16.724 5.03516 16.8672 5.10026 16.9844 5.23047C17.1016 5.34766 17.1602 5.49089 17.1602 5.66016V9.41016C17.1602 9.41016 17.1602 9.41667 17.1602 9.42969C17.1602 9.42969 17.1602 9.4362 17.1602 9.44922C17.1602 9.46224 17.1602 9.46875 17.1602 9.46875C17.1602 9.48177 17.1602 9.49479 17.1602 9.50781C17.1602 9.52083 17.1602 9.53385 17.1602 9.54688C17.1471 9.5599 17.1406 9.57292 17.1406 9.58594C17.1406 9.58594 17.1406 9.59245 17.1406 9.60547C17.1406 9.60547 17.1406 9.61198 17.1406 9.625C17.1406 9.625 17.1341 9.63151 17.1211 9.64453C17.1211 9.64453 17.1211 9.65104 17.1211 9.66406C17.1211 9.66406 17.1146 9.67057 17.1016 9.68359C17.1016 9.68359 17.1016 9.6901 17.1016 9.70312C17.0885 9.71615 17.082 9.72917 17.082 9.74219C17.069 9.76823 17.056 9.78776 17.043 9.80078C17.0299 9.8138 17.0169 9.82682 17.0039 9.83984L17.043 9.78125C17.043 9.79427 17.0365 9.80729 17.0234 9.82031L17.0039 9.83984C17.0039 9.83984 17.0039 9.84635 17.0039 9.85938C17.0039 9.85938 16.9974 9.85938 16.9844 9.85938C16.9844 9.85938 16.9844 9.86589 16.9844 9.87891C16.9714 9.87891 16.9583 9.88542 16.9453 9.89844C16.9453 9.89844 16.9388 9.90495 16.9258 9.91797C16.9258 9.91797 16.9193 9.92448 16.9062 9.9375C16.9062 9.9375 16.8997 9.9375 16.8867 9.9375C16.8737 9.95052 16.8607 9.95703 16.8477 9.95703C16.8477 9.95703 16.8411 9.96354 16.8281 9.97656C16.8281 9.97656 16.8216 9.98307 16.8086 9.99609C16.8086 9.99609 16.8021 9.99609 16.7891 9.99609C16.7891 9.99609 16.7826 9.99609 16.7695 9.99609C16.7565 10.0091 16.7435 10.0156 16.7305 10.0156C16.7305 10.0156 16.724 10.0156 16.7109 10.0156C16.7109 10.0156 16.7044 10.0221 16.6914 10.0352C16.6654 10.0352 16.6393 10.0352 16.6133 10.0352C16.6003 10.0352 16.5807 10.0352 16.5547 10.0352H16.6328C16.6198 10.0352 16.6133 10.0352 16.6133 10.0352C16.6133 10.0352 16.6068 10.0352 16.5938 10.0352H16.5547H12.9219C12.7526 10.0352 12.6094 9.97656 12.4922 9.85938C12.375 9.74219 12.3164 9.59245 12.3164 9.41016C12.3164 9.24089 12.375 9.09766 12.4922 8.98047C12.6094 8.85026 12.7526 8.78516 12.9219 8.78516H15.0312L13.332 7.125C12.9544 6.7474 12.5378 6.44141 12.082 6.20703C11.6393 5.97266 11.1706 5.81641 10.6758 5.73828C10.181 5.64714 9.6862 5.64062 9.19141 5.71875C8.68359 5.79688 8.20182 5.95312 7.74609 6.1875L7.55078 6.28516C7.08203 6.55859 6.67188 6.89714 6.32031 7.30078C5.96875 7.69141 5.68229 8.13411 5.46094 8.62891C5.2526 9.11068 5.1224 9.61849 5.07031 10.1523C5.01823 10.6862 5.05078 11.2266 5.16797 11.7734C5.28516 12.3203 5.48047 12.8216 5.75391 13.2773C6.02734 13.7331 6.35938 14.1367 6.75 14.4883C7.15365 14.8268 7.59635 15.1003 8.07812 15.3086C8.5599 15.5039 9.07422 15.6211 9.62109 15.6602C10.1549 15.6862 10.6758 15.6276 11.1836 15.4844C11.6914 15.3411 12.1536 15.1263 12.5703 14.8398C13 14.5404 13.3776 14.1823 13.7031 13.7656C14.0286 13.3359 14.2826 12.8607 14.4648 12.3398C14.5169 12.1706 14.6211 12.0534 14.7773 11.9883C14.9336 11.9102 15.0898 11.8971 15.2461 11.9492C15.4023 12.0143 15.513 12.125 15.5781 12.2812C15.6562 12.4245 15.6693 12.5807 15.6172 12.75C15.3828 13.401 15.0638 13.9935 14.6602 14.5273C14.2565 15.0612 13.7878 15.5104 13.2539 15.875C12.7201 16.2396 12.1341 16.513 11.4961 16.6953C10.8711 16.8776 10.2201 16.9492 9.54297 16.9102C8.86589 16.8711 8.22786 16.7214 7.62891 16.4609C7.01693 16.2005 6.46354 15.862 5.96875 15.4453C5.48698 15.0156 5.07031 14.5078 4.71875 13.9219C4.38021 13.349 4.13281 12.724 3.97656 12.0469C3.83333 11.3698 3.79427 10.6927 3.85938 10.0156C3.9375 9.35156 4.10677 8.72005 4.36719 8.12109C4.6276 7.50911 4.97917 6.94922 5.42188 6.44141C5.86458 5.94661 6.37891 5.52995 6.96484 5.19141Z",
      fill: "currentColor"
    }
  )
);
const SvgRefresh = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Refresh_default = SvgRefresh;
